export default __webpack_public_path__ + "static/media/login.dda50ee7.png";